import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import Popup from './../popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';
import { FormattedMessage, injectIntl } from 'react-intl';

export const ConfigCalendar = injectIntl(class extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      resources: [],
      services: [],
      profiles: [],
      loading: true,
      date: curDate,
      calendarType: 1,
      param: {},
      company: {startTime: "09:00:00", endTime: "20:00:00"},
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
  }

  componentDidMount() {
    this.populateCompaniesData();
  }

  prevMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() - 1);
    this.setState(prevState => ({...prevState, date: date}));
    this.populateResourcesData(this.state.companyId, this.state.date);
  }

  nextMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() + 1);
    this.setState(prevState => ({...prevState, date: date}));
    this.populateResourcesData(this.state.companyId, this.state.date);
  }

  selectParamService(service, param) {
    console.log(param);
    var cs = param.companyServices.filter(cs => cs.serviceId === service.id);
    this.setState(prevState => ({...prevState, paramservice: service, param: cs.length > 0 ? cs[0] : {}}));
  }

  async handleSaveDay(day, resId) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/operatedaycompanyservice/${day.id}/${resId}/${this.state.paramservice.id}`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.param)
    });
    const newParam = await response.json();

    var resources = this.state.resources;
    resources.forEach(res => {
      if (res.id === resId) {
        res.operateDays.forEach(od => {
          if (od.id === day.id) {
            od.companyServices = od.companyServices.filter(cs => cs.id !== newParam.id);
            od.companyServices.push(newParam);
          }
        });
      }
    });
    this.setState(prevState => ({...prevState, resources: resources}));
  }

  async setDay(resource, day) {
    var resources = this.state.resources;
    var remove = resource.workingDays.includes(day);

    var selectedDate = new Date(this.state.date.getFullYear(), this.state.date.getMonth(), day);
    var date = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000);
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/resources/${resource.id}/calendar`, {
      method: remove ? "DELETE" : "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({day: date, allDays: day === 0, dayOfWeek: day < 0 ? -day : null})
    });
    const newDay = await response.json();

    if (remove) {
      resource.workingDays = resource.workingDays.filter(d => d !== day);
      resource.operateDays = resource.operateDays.filter(d => d.day !== day);
    }
    else {
      resource.workingDays.push(day);
      resource.operateDays.push({id: newDay.id, day: day, companyServices: []});
    }
    this.setState(prevState => ({...prevState, resources: resources}));
  }

  renderParamOptions(resource, param) {
    return (
      <>
      <h4>{resource.name} ({param.day})</h4>
      <div class="btndelete" onClick={() => this.setDay(resource, param.day)}><FormattedMessage id="delete_day"/></div>

      <div class="tablediv">

        <div><FormattedMessage id="resource_services"/></div>
        <table className='table table-striped' aria-labelledby="tabelLabel">
          <thead>
            <tr>
              <th><FormattedMessage id="name"/></th>
              <th><FormattedMessage id="price"/></th>
              <th><FormattedMessage id="min_time"/></th>
              <th><FormattedMessage id="max_time"/></th>
              <th><FormattedMessage id="editable"/></th>
            </tr>
          </thead>
          <tbody>
            {this.state.services.filter(service => service.assigned).map(service =>
              <tr key={service.id} onClick={() => this.selectParamService(service, param)} class={this.state.paramservice?.id === service.id?'react-calendar__tile--active':''}>
                <td>{service.name}</td>
                <td>{service.price}</td>
                <td>{service.minTime}</td>
                <td>{service.maxTime}</td>
                <td>{service.timeEditable ? '✔' : ''}</td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
        <div class="form-group">
          <label for="Input_BookingProfile"><FormattedMessage id="resource_profile"/></label>
          <select class="form-control" id="Input_BookingProfile" name="Input.BookingProfile"
            value={this.state.param.profileId ? this.state.param.profileId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, profileId: val && val.length>0?parseInt(val):null}}));}}>
              <option value="0"></option>
              {this.state.profiles.map(profile => <option value={profile.id}>{profile.name}</option>)}
          </select>
        </div>

        <div class="form-group">
          <label for="Input_ServicePrice"><FormattedMessage id="service_price"/></label>
          <input class="form-control" type="text" id="Input_ServicePrice" name="Input.ServicePrice"
            value={this.state.param.price ? this.state.param.price : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, price: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMinTime"><FormattedMessage id="service_min_duration"/></label>
          <input class="form-control" type="text" id="Input_ServiceMinTime" name="Input.ServiceMinTime"
            value={this.state.param.minimumTime ? this.state.param.minimumTime : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, minimumTime: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceMaxTime"><FormattedMessage id="service_max_duration"/></label>
          <input class="form-control" type="text" id="Input_ServiceMaxTime" name="Input.ServiceMaxTime"
            value={this.state.param.maximumTime ? this.state.param.maximumTime : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, maximumTime: val.length>0?val:null}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_BookingInterval"><FormattedMessage id="service_interval"/></label>
          <select class="form-control" id="Input_BookingInterval" name="Input.BookingInterval"
            value={this.state.param.bookingInterval ? this.state.param.bookingInterval.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, bookingInterval: val}}));}}>
              <option value="1"><FormattedMessage id="interval_min"/></option>
              <option value="2"><FormattedMessage id="interval_5min"/></option>
              <option value="3"><FormattedMessage id="interval_hour"/></option>
              <option value="4"><FormattedMessage id="interval_day"/></option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_PartialBooking"><FormattedMessage id="partial_booking"/></label>
          <select class="form-control" id="Input_PartialBooking" name="Input.PartialBooking"
            value={this.state.param.partialBooking ? this.state.param.partialBooking.toString() : 'null'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, param: {...prevState.param, partialBooking: val === 'null' ? null : val}}));}}>
              <option value="null"><FormattedMessage id="partial_off"/></option>
              <option value="2">2 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="3">3 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="4">4 <FormattedMessage id="partials_2_4_members"/></option>
              <option value="5">5 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="6">6 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="7">7 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="8">8 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="9">9 <FormattedMessage id="partials_5_10_members"/></option>
              <option value="10">10 <FormattedMessage id="partials_5_10_members"/></option>
          </select>
        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value={this.props.intl.formatMessage({id: "save"})} id="Button_Save" onClick={() => this.handleSaveDay(param, resource.id)}/>
      </>
    );
  }

  renderPopup(resource, day) {
    return resource.workingDays.includes(day)?
      <Popup
        className="popup-info"
        trigger={open => <td class="react-calendar__tile--active filteroptcal"></td>}
        position="bottom center"
        onOpen={() => this.populateServicesData(this.state.companyId, resource.id, resource.operateDays.filter(o => o.day == day)[0])}
        closeOnDocumentClick>{() => this.renderParamOptions(resource, resource.operateDays.filter(o => o.day == day)[0])}</Popup>
      : <td onClick={() => this.setDay(resource, day)}></td>
  }

  renderCalendarTable() {
    var date = this.state.date;
    var daysinmonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    return (
      <>
      
        <div><span className="radio-primary">
            <input name="CalendarType" type="radio" value="RadioOwn" id="RadioOwn" checked={this.state.calendarType === 1} onClick={() => this.setState(prevState => ({...prevState, calendarType: 1}))}/><label className="btn btn-primary btn-tab" for="RadioOwn"><FormattedMessage id="by_dates"/></label>
            <input name="CalendarType" type="radio" value="RadioOther" id="RadioOther" checked={this.state.calendarType === 2} onClick={() => this.setState(prevState => ({...prevState, calendarType: 2}))}/><label className="btn btn-primary btn-tab" for="RadioOther"><FormattedMessage id="by_days"/></label>
            </span>
            </div>
      
      {this.state.calendarType == 1 ?
      <><table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th width="16px" onClick={() => this.prevMonth()}>&lt;</th>
            <th colspan={daysinmonth}>{this.state.date.toLocaleString(undefined, {month: '2-digit', year: 'numeric'})}</th>
            <th width="16px" onClick={() => this.nextMonth()}>&gt;</th>
          </tr>
        </thead>
      </table>
      <div class="tabledivmid">

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr key="days">
            <th></th>
            <td><FormattedMessage id="all"/></td>
            {Array.from(Array(daysinmonth).keys()).map(pos => <td class={new Date(date.getFullYear(), date.getMonth(), pos + 1).getDay() === 0 || new Date(date.getFullYear(), date.getMonth(), pos + 1).getDay() === 6 ? "day-weekend" : ""}>{pos + 1}</td>)}
            <td></td>
          </tr>
        </thead>
        <tbody>
          {this.state.resources.map(resource =>
            <tr key={resource.name}>
              <th>{resource.name}</th>
              {this.renderPopup(resource, 0)}
              {Array.from(Array(daysinmonth).keys()).map(pos => this.renderPopup(resource, pos + 1))}
              <td></td>
            </tr>
          )}
        </tbody>
      </table>

      </div></> : <></>}

      {this.state.calendarType == 2 ?
      <div class="tabledivmid">

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <tbody>
          <tr key="days">
            <th></th>
            <td><FormattedMessage id="all"/></td>
            {Array.from(Array(7).keys()).map(pos => <td class={new Date(2018, 0, pos + 1).getDay() === 0 || new Date(2018, 0, pos + 1).getDay() === 6 ? "day-weekend" : ""}>{new Date(2018, 0, pos + 1).toLocaleDateString('en-US', { weekday: 'short' })}</td>)}
          </tr>
          {this.state.resources.map(resource =>
            <tr key={resource.name}>
              <th>{resource.name}</th>
              {this.renderPopup(resource, 0)}
              {Array.from(Array(7).keys()).map(pos => this.renderPopup(resource, -(pos + 1)))}
            </tr>
          )}
        </tbody>
      </table>

      </div> : <></>}</>
    );
  }

  updateCompanyStartTime(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, company: {...prevState.company, startTime: val + ":00"}}));
    this.saveCompanyHours();
  }

  updateCompanyEndTime(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, company: {...prevState.company, endTime: val + ":00"}}));
    this.saveCompanyHours();
  }

  async saveCompanyHours() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/hours`, {
      method: "PUT",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.company)
    });
    await response.json();
  }

  render() {
    let contents = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderCalendarTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="calendar" />
        <div class="headerdiv"><h4 id="tabelLabel"><FormattedMessage id="working_calendar"/></h4></div>
        {contents}
        <div class="form-group">
          <label for="Input_BookingProfile"><FormattedMessage id="resource_profile"/></label>
          <select class="form-control" id="Input_BookingProfile" name="Input.BookingProfile"
            value={this.state.profileId ? this.state.profileId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profileId: parseInt(val)}));}}>
              <option value="0"></option>
              {this.state.profiles.map(profile => <option value={profile.id}>{profile.name}</option>)}
          </select>
        </div>
        <div style={{marginTop: "5px"}}>
          <label for="company-starttime"><FormattedMessage id="working_hours"/></label>
          <input id="company-starttime" type="time" name="company-starttime" step="60" value={this.state.company.startTime} onChange={evt => this.updateCompanyStartTime(evt)}/>
          <input id="company-endtime" type="time" name="company-endtime" step="60" value={this.state.company.endTime} onChange={evt => this.updateCompanyEndTime(evt)}/>
          <small><FormattedMessage id="can_override"/></small>
        </div>

        <div class="configgroup">
        <div class="availheader"><FormattedMessage id="lunch_break"/></div>
          <label for="company-lbstarttime"><FormattedMessage id="company_lunch"/></label>
          <input id="company-lbstarttime" type="time" name="company-lbstarttime" step="60" value="13:00:00"/>
          <input id="company-lbendtime" type="time" name="company-lbendtime" step="60" value="14:00:00"/>
          <div><label for="interval-is-floating"><FormattedMessage id="interval_floating"/></label>
          <input type="checkbox" name="interval-is-floating"/>
          <label for="company-lblength"><FormattedMessage id="interval_length"/></label>
          <input id="company-lblength" type="number" name="company-lblength" value="1"/></div>
          <small><FormattedMessage id="can_override"/></small>
        </div>
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
      const ownCompanies = this.state.companies.filter(c => this.state.companyId === 0 || c.id === this.state.companyId);
      if (ownCompanies.length > 0) {
        this.setState(prevState => ({...prevState, companyId: ownCompanies[0].id}));
        this.populateResourcesData(ownCompanies[0].id, this.state.date);
        this.populateWorkingTimeData(ownCompanies[0].id);
        this.populateProfilesData(ownCompanies[0].id);
      } else {
        window.location.replace(`/configcompany/${this.state.companyId}`);
      }
    }
  }

  async populateResourcesData(companyId, month) {
    var selectedDate = new Date(this.state.date.getFullYear(), this.state.date.getMonth(), 1);
    var date = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000);
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/resources?month=${date.toLocaleDateString('en-US')}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resources: data, loading: false}));
  }

  async populateServicesData(companyId, resourceId, day) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/${resourceId}/services`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, services: data}));
    this.selectParamService(data.filter(service => service.assigned)[0], day);
  }

  async populateWorkingTimeData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/monthcalendar`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    if (data.length > 0)
      this.setState(prevState => ({...prevState, company: data[0]}));
  }

  async populateProfilesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/profiles`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, profiles: data, loading: false}));
  }
})